export default "__VITE_ASSET__a5fa7229__"